
import BusinessContinuityExport_CriticalBusinessFunctionsController from 'controllers/business_continuity_export/critical_business_functions_controller'

export default class BusinessContinuityExport_EmployeeCommunicationProceduresContactListController extends BusinessContinuityExport_CriticalBusinessFunctionsController { }
